import { useFlags } from 'launchdarkly-react-client-sdk';
import { useContext, useEffect, useState } from 'react';
import usePaginatedEvents from './PaginatedEvents';
import { EventDateContext } from 'contexts/eventDate';
import { EventStatusContext } from 'contexts/eventStatus';
import { EventTypeContext } from 'contexts/eventType';
import { useCurrentUserState } from 'contexts/user';
import { EVENTS_PAGINATION_PAGE_SIZE } from 'modules/events/basics/constants/list.constants';
import { MarketWithAll } from 'modules/events/basics/types/events.types';

const usePastEvents = () => {
  const { user } = useCurrentUserState();
  const flags = useFlags();
  const showRsvpEvents = flags.eventsBiogenlinc4973ShowRsvpEvents;
  const market = user?.market ? (user.market as MarketWithAll) : null;
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(EVENTS_PAGINATION_PAGE_SIZE);

  const eventDateContext = useContext(EventDateContext);
  const eventStatusContext = useContext(EventStatusContext);
  const eventTypeContext = useContext(EventTypeContext);

  const {
    data,
    loading,
    totalCount,
  } = usePaginatedEvents({
    isPast: true,
    market,
    showRsvpEvents,
    sortOrder: 'desc',
    pageSize,
    page,
    eventStatus: eventStatusContext.eventStatus,
    eventType: eventTypeContext.eventType,
    dateRange: eventDateContext.date,
  });

  useEffect(() => {
    setPage(0);
  }, [market, eventStatusContext.eventStatus, eventTypeContext.eventType, eventDateContext.date]);

  return {
    pastEvents: data || [],
    loadingPast: loading,
    page,
    setPage,
    pageSize,
    setPageSize,
    totalCount,
  };
};

export default usePastEvents;
